import $ from "jquery";
import HTML2PDF from "@rmlibrary/html-pdf";
import * as formatter from "@rmlibrary/formatting";

const IE_11 = !!window.MSInputMethodContext && !!document.documentMode;
const IS_SAFARI = window.safari && window.safari.pushNotification.toString() === "[object SafariRemoteNotification]";

const CHARACTER_MAP = [
    { pattern: /\u2011/g, replacement: "-" },
    { pattern: "’", replacement: "'" },
];

// const formatter = new Formatter();
const lang = document.documentElement.lang;

function getVar(obj, path) {
    function _getVar(obj, pathParts) {
        if (pathParts.length === 0) return obj;
        const [first, ...rest] = pathParts;
        if (!obj || typeof obj !== "object") return;
        return _getVar(obj[first], rest);
    }

    if (!path) return null;
    return _getVar(obj, path.split("."));
}

function outputAttribute(pdfElement, attrName, inputs, fn) {
    $(pdfElement)
        .find(`[${attrName}]`)
        .each((i, el) => {
            const path = el.getAttribute(attrName);
            const v = getVar(inputs, path);
            fn(el, v);
        });
}

export function populatePDF(pdfContainer, inputs, isDebug = false, isGenerate = false) {
    // let pdfContainer = document.getElementById("pre-pdf-container");

    outputAttribute(pdfContainer, "data-output", inputs, (el, v) => {
        if (v) {
            const renderAs = el.getAttribute("data-output-render-as") || "text";
            const makeLowerCase = el.hasAttribute("data-output-lowercase");
            let value = v.toString();
            if (makeLowerCase) {
                value = value.toLowerCase();
            }

            if (renderAs === "html") {
                el.innerHTML = value;
            } else {
                el.innerText = value;
            }
        } else {
            el.innerText = "";
        }
    });
    outputAttribute(pdfContainer, "data-output-number", inputs, (el, v) => {
        const decimals = Number(el.getAttribute("data-output-decimals")) || 0;
        try {
            el.innerText = formatter.formatNumber(v, { lang, decPlaces: decimals });
        } catch (e) {
            el.innerText = "";
        }
    });
    outputAttribute(pdfContainer, "data-output-percentage", inputs, (el, v) => {
        const decimals = Number(el.getAttribute("data-output-decimals")) || 0;
        try {
            el.innerText = formatter.formatPercentage(v * 100, { lang, decPlaces: decimals });
        } catch (e) {
            el.innerText = "";
        }
    });
    outputAttribute(pdfContainer, "data-output-currency", inputs, (el, v) => {
        const decimals = Number(el.getAttribute("data-output-decimals")) || 0;
        try {
            el.innerText = formatter.formatCurrency(v, { lang, decPlaces: decimals });
        } catch (e) {
            el.innerText = "";
        }
    });
    outputAttribute(pdfContainer, "data-output-date", inputs, (el, v) => {
        try {
            el.innerText = formatter.formatDate(new Date(), "mmmm dd, yyyy", lang);
        } catch (e) {
            el.innerText = "";
        }
    });
    if (!isGenerate) {
        outputAttribute(pdfContainer, "data-src", inputs, (el, v) => {
            el.setAttribute("src", v);
        });
    }
    outputAttribute(pdfContainer, "data-if", inputs, (el, v) => {
        if (!v) el.style.display = "none";
        else el.style.display = "";
    });
    outputAttribute(pdfContainer, "data-alt", inputs, (el, v) => {
        el.setAttribute("alt", v);
    });

    HTML2PDF.defineField("page-number", (pdf) => {
        return pdf.doc.getCurrentPageInfo().pageNumber - 1;
    });

    HTML2PDF.defineField("total-minus-cover", () => {
        return HTML2PDF.getFieldValue("total-pages") - 1;
    });
}

export function generatePDF(inputs, isDebug = false) {
    let pdfContainer = document.getElementById("pre-pdf-container");
    
    populatePDF(pdfContainer, inputs, isDebug, true);

    const pdf = HTML2PDF.generate(pdfContainer, {
        characterMap: CHARACTER_MAP
    });
    pdf.doc.a11yMetadata(lang === "en" ? "Scotiabank - Mortgage Prepayment Charge Calculator" : "Calculateur de frais de remboursement anticipé hypothécaire");

    return pdf;
}

let printFrame = null;
let printType = null;

export function printPDF(inputs) {
    // console.log(inputs);
    const pdf = generatePDF(inputs);

    if (!IE_11 && !printFrame) {
        if (navigator.mimeTypes["application/pdf"] || /firefox\/\d+\./i.test(navigator.userAgent)) {
            printType = "bloburi";
            printFrame = document.createElement("iframe");
            printFrame.style.position = "absolute";
            printFrame.style.top = "0px";
            printFrame.style.left = "-10000px";
            printFrame.style.width = "100px";
            printFrame.style.height = "100px";
            document.body.appendChild(printFrame);
        }
    }
    pdf.doc.autoPrint();
    if (IS_SAFARI) {
        printFrame.src = pdf.doc.output(printType);
        setTimeout(() => {
            printFrame.contentWindow.print();
        }, 500);
    } else if (IE_11) {
        const blob = pdf.doc.output("blob");
        window.navigator.msSaveOrOpenBlob(
            blob,
            lang === "en" ? "Scotiabank - Mortgage Prepayment Charge Calculator.pdf" : "Calculateur de frais de remboursement anticipé hypothécaire.pdf",
        );
    } else if (printFrame) {
        printFrame.src = pdf.doc.output(printType);
    } else {
        pdf.doc.save(
            lang === "en" ? "Scotiabank - Mortgage Prepayment Charge Calculator.pdf" : "Calculateur de frais de remboursement anticipé hypothécaire.pdf",
        );
    }
}
